<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-row>
				<v-col cols="12" class="d-flex">
					<div style="width: 200px;" >
						<v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value"
							label="年份" dense outlined></v-select>
					</div>
					<v-btn class="ml-2" color="info" @click="refresh">刷新</v-btn>
				</v-col>
			</v-row>
	
			<v-row dense>
				<v-col cols="6">
					<v-card>
						<v-card-title class="d-flex">
							<div class="mt-n5">月新增学员</div>
							
							<v-spacer></v-spacer>
							<span>{{summaryText}}</span>
						</v-card-title>
						<v-card-text>
							<ve-histogram  :data="chartData" height="400px" :extend="chartExtend" :judge-width="true"></ve-histogram>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card>
						<v-card-title>生源类型占比 TOP5</v-card-title>
						<v-card-text>
							<ve-pie :data="sourceTypeData" :settings="sourceTypeSettings"></ve-pie>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card>
						<v-card-title>就读学校分布  TOP5</v-card-title>
						<v-card-text>
							<ve-pie :data="fromSchoolData" :settings="fromSchoolSettings"></ve-pie>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card>
						<v-card-title>居住片区分布 TOP5</v-card-title>
						<v-card-text>
							<ve-bar :data="fromRegionData" :judge-width="true" :extend="regionExtend"></ve-bar>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<!-- <v-row>
				<v-col cols="12" class="d-flex justify-center">
					<span class="text-h6">{{summaryText}}</span>
				</v-col>
			</v-row> -->
		</v-card-text>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "student-dashboard",
		data() {
			this.chartExtend = {
			  
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			},
			this.sourceTypeSettings = {
				//roseType: 'radius'
			},
			this.fromSchoolSettings = {
				type:'pie',
			},
			this.regionExtend={
				series: {
					barWidth: 40,
					label:{show:true,position:'right'}
				}
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '学员报表',
						disabled: true
					},
				],
				shopId:"",
				yearItems:[],
				chartData: {
					columns: ['月份', '新增学员数'],
					rows: [],
				},
				summaryText:"",
				query: {
					year:""+new Date().getFullYear()
				},
				sourceTypeData:{
					columns: ['类型名称', '学员数'],
					rows: [],
				},
				fromSchoolData:{
					columns: [],
					rows: [],
				},
				fromRegionData:{
					columns: [],
					rows: [],
				}
			}
		},
		mounted() {
			this.generateYearItems();
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			
			this.refresh();
		},
		
		methods: {
			refresh(){
				this.getChartData();
				// 获取生源类型占比
				this.getStudentFromChartData("1");
				// 获取就读学校占比
				this.getStudentFromChartData("2");
				// 获取居住片区占比
				this.getStudentFromChartData("3");
			},
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			getChartData() {

				const that = this;

				let url = `/report/student/count/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
				
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]);
						
						that.chartData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
						that.chartData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						that.summaryText  =  response.data["data"]["summaryText"];
						
						return
					}

				})
			},
			getStudentFromChartData(dataType) {
			
				const that = this;
			
				let url = `/report/student/from/count/${dataType}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if(this.query.year){
					url += "&year=" + this.query.year;
				}
				
				console.log(url);
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
				
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]);
						if (dataType == '1'){
							that.sourceTypeData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
							that.sourceTypeData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
							
						}else if (dataType =='2'){
							that.fromSchoolData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
							that.fromSchoolData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						}else if (dataType =='3'){
							that.fromRegionData.columns = response.data["data"]["labels"] ? response.data["data"]["labels"] : [];
							that.fromRegionData.rows = response.data["data"]["dataList"]? response.data["data"]["dataList"] : [];
						}
						
						
						
						return
					}
			
				})
			},
			
			
		}
	}
</script>

<style>
</style>
